import React from "react";
import { api } from "@/lib/api";
import { euro } from "@/lib/format";
import { RicercaAsync } from "./RicercaAsync";

const cerca = async (q) => (await api.get("/prezzario/cerca", { params: { q, limit: 40 } })).data.map((v) => ({ ...v, id: v.codice }));
const risolvi = async (codice) => { try { const v = (await api.get(`/prezzario/voce/${encodeURIComponent(codice)}`)).data; return { ...v, id: v.codice }; } catch { return null; } };
const label = (v) => `${v.codice_breve || v.codice} · ${v.descrizione} (${v.um} · ${euro(v.prezzo)})`;

// Ricerca nel Prezzario Regione Piemonte (sola lettura) per codice o parola chiave
export function RicercaPrezzario({ value, onChange, testid = "prezzario-search", className }) {
  return <RicercaAsync value={value} onChange={onChange} cerca={cerca} risolvi={risolvi} label={label} placeholder="Cerca nel Prezzario per codice (es. 01.A01) o parola chiave…" testid={testid} className={className} />;
}
